import * as React from 'react';
import { findDOMNode } from 'react-dom';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

export interface ScrollbarProps {
    className?: string;
    scrollBottom?: boolean;
    wheelPropagation?: boolean;
}

export default class Scrollbar extends React.Component<ScrollbarProps> {
    private container: HTMLDivElement | null = null;
    private ps?: PerfectScrollbar;
    private scrollBottomValue = 0;

    render() {
        return <div className={this.props.className}>{this.props.children}</div>;
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-find-dom-node
        this.container = findDOMNode(this) as HTMLDivElement;
        this.ps = new PerfectScrollbar(this.container, {
            wheelPropagation: this.props.wheelPropagation || false,
        });
        if (this.props.scrollBottom) {
            this.scrollBottom();
            setTimeout(this.scrollBottom, 50);
        }
    }

    componentWillUnmount() {
        if (!this.container) {
            return;
        }
        this.container.scrollTop = 0;
        if (this.ps) {
            this.ps.destroy();
        }
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillUpdate() {
        if (!this.container) {
            return;
        }
        this.scrollBottomValue = this.container.scrollHeight - this.container.clientHeight - this.container.scrollTop;
    }

    componentDidUpdate() {
        if (this.scrollBottomValue < 50) {
            this.scrollBottom();
        }
    }

    scrollBottom = () => {
        if (!this.container) {
            return;
        }
        this.container.scrollTop = this.container.scrollHeight - this.container.clientHeight;
        if (this.ps) {
            this.ps.update();
        }
    };
}
